import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    productId: string;            
};

type HandlerType = Handler<Parameter>;

const DispatchRemoveClipboardItem: HandlerType = props => {    
    props.dispatch({
        type: "Widgets/Clipboard/RemoveItem",
        parameter: {            
            productId: props.parameter.productId,
        },
    });
};

const chain = [DispatchRemoveClipboardItem];

const removeClipboardItem = createHandlerChainRunner(chain, "RemoveClipboardItem");
export default removeClipboardItem;
